export const NAVBAR_LINKS = [
  {
    name: 'About',
    link: 'mission',
  },
  {
    name: 'Whitepaper',
    link: 'whitepaper',
  },
  {
    name: 'Contact',
    link: 'contact',
  },
  {
    name: '|',
    link: '',
  },
  {
    name: 'Data',
    link: 'dataGraph',
  },
  {
    name: 'Swap',
    link: 'swap',
  },
];
